import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../page/login/login'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('../page/login/register.vue'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '/linkWechat',
      name: 'linkWechat',
      component: () => import('../page/login/linkWechat.vue'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '/',
      name: 'index',
      component: () => import('../page/index/index.vue')
    },
    {
      path: '/newProject',
      name: 'newProject',
      component: () => import('../page/index/newProject')
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('../page/index/user')
    },
    {
      path: '/attendance',
      name: 'attendance',
      component: () => import('../page/index/attendance')
    },
    {
      path: '/attendance/:id',
      name: 'attendanceDetail',
      component: () => import('../page/index/attendanceDetail')
    },
    {
      path: '/quotation',
      name: 'quotation',
      component: () => import('../page/index/quotation')
    },
    {
      path: '/quotation/:id',
      name: 'quotationDetail',
      component: () => import('../page/index/quotationDetail')
    },
    {
      path: '/expense',
      name: 'expense',
      component: () => import('../page/index/expense')
    },
    {
      path: '/consulting',
      name: 'consulting',
      component: () => import('../page/index/consulting')
    },
    {
      path: '/gitUser',
      name: 'gitUser',
      component: () => import('../page/index/gitUser')
    },
    {
      path: '/issues',
      name: 'issues',
      component: () => import('../components/issues')
    },
    {
      path: '/issues/new',
      name: 'new-project-issue',
      component: () => import('../page/project/newIssue')
    },
    {
      path: '/issues/:id',
      name: 'project-issue-detail',
      component: () => import('../page/project/issueDetail')
    },
    {
      path: '/doc',
      name: 'doc',
      component: () => import('../page/index/doc')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../page/index/profile')
    },
    {
      path: '/wages',
      name: 'wages',
      component: () => import('../page/index/wages')
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: () => import('../page/index/resetPassword')
    },
    {
      path: '/project/:name',
      name: 'project-index',
      component: () => import('../page/project/index.vue'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/info',
      name: 'project-info',
      component: () => import('../page/project/info.vue'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/user',
      name: 'project-user',
      component: () => import('../page/project/user'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/issues',
      name: 'project-issues',
      component: () => import('../components/issues'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/newIssue',
      name: 'new-issue',
      component: () => import('../page/project/newIssue'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/issueDetail/:number',
      name: 'issue-detail',
      component: () => import('../page/project/issueDetail'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/design',
      name: 'project-design',
      component: () => import('../page/project/design'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/figma/:id',
      name: 'project-figma',
      component: () => import('../page/project/figma'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/documents',
      name: 'project-document',
      component: () => import('../page/project/documentList'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/documents/:id',
      name: 'project-document-detail',
      component: () => import('../page/project/documentDetail'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/documentEdit/:id',
      name: 'project-document-edit',
      component: () => import('../page/project/documentEdit'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/quotation',
      name: 'project-quotation',
      component: () => import('../page/project/quotation'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/appReleases',
      name: 'project-app-releases',
      component: () => import('../page/project/appReleases'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/setup',
      name: 'project-setup',
      component: () => import('../page/project/setup.vue'),
      meta: {
        layout: 'project'
      }
    },
    {
      path: '/project/:name/smsTemplate',
      name: 'sms-template',
      component: () => import('../page/project/smsTemplate.vue'),
      meta: {
        layout: 'project'
      }
    },
  ]
})
export default router
